/**
 * @generated SignedSource<<a2f21bf42fa55755245332713cae7139>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type IntegrationLinkJiraProjectQuery$variables = {
  projectId: string;
};
export type IntegrationLinkJiraProjectQuery$data = {
  readonly viewer: {
    readonly jiraProject: {
      readonly id: string;
      readonly jiraIssueTypes: ReadonlyArray<{
        readonly externalId: string | null;
        readonly iconUrl: string | null;
        readonly id: string;
        readonly name: string | null;
      }>;
      readonly key: string;
      readonly name: string;
      readonly pushStatus: boolean;
      readonly twoWaySync: boolean;
    };
  };
};
export type IntegrationLinkJiraProjectQuery = {
  response: IntegrationLinkJiraProjectQuery$data;
  variables: IntegrationLinkJiraProjectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "projectId",
      "variableName": "projectId"
    }
  ],
  "concreteType": "JiraProject",
  "kind": "LinkedField",
  "name": "jiraProject",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pushStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "twoWaySync",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "jiraIssueTypes",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "iconUrl",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationLinkJiraProjectQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationLinkJiraProjectQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8db8e8587229f017c9db566162c608f6",
    "id": null,
    "metadata": {},
    "name": "IntegrationLinkJiraProjectQuery",
    "operationKind": "query",
    "text": "query IntegrationLinkJiraProjectQuery(\n  $projectId: String!\n) {\n  viewer {\n    jiraProject(projectId: $projectId) {\n      id\n      name\n      key\n      pushStatus\n      twoWaySync\n      jiraIssueTypes {\n        name\n        iconUrl\n        id\n        externalId\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0d1eb986ce4a316b87e6e2cb9d7eeb79";

export default node;
